import React from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

export interface IMessageRequire {
  message?: string | null;
  classWrapper?: string;
  isWarning?: boolean;
  labelClass?: string;
}
export default function MessageError({
  message,
  classWrapper = 'ms-2',
  isWarning,
  labelClass = 'mt-1',
}: IMessageRequire): JSX.Element {
  if (message) {
    return (
      <div className={classWrapper}>
        <small
          className={`text-cherry d-flex align-items-center ${isWarning && 'text-dark-red'} ${
            labelClass ?? ''
          }`}
        >
          <ExclamationTriangleFill />
          <span className="d-block px-1">{message}</span>
        </small>
      </div>
    );
  }
  return <></>;
}
